import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import contactImage from "../img/profile.svg";
import styles from "./Call.module.scss";

const Call = () => {
  return (
    <div className={styles.Call} id="contact">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={12} lg={5}>
            <Image
              src={contactImage}
              alt="contact-image"
              className={styles.contactImage}
              fluid
            />
          </Col>

          <Col md={12} lg={5} className={styles.textContainer}>
            <h2 className="pt-3">Contact me</h2>
            <div>
              <p>
                I've always been interested mainly in web technologies.
                Throughout the years I've worked with various programming
                languages and tools. My journey started with HTML, CSS,
                Javascript. Then I switched to C++, but when React came out, I
                immediately fell in love with it and started tinkering since
                2016 and then I found my first dev job in inSociety s.r.o. As
                I've had decent knowledge of Javascript I chose Node.js for the
                backend, but in the past I used to use PHP for the server side.
                I've always been and still am working as a freelancer. Usually I
                create websites or web apps, chrome extensions for internal use
                of the companies.
              </p>
            </div>
            <div className="iconArea pt-3">
              <div className={styles.iconList}>
                <div className="pr-2">
                  <FontAwesomeIcon
                    icon={faPhone}
                    className={styles.phoneIcon}
                  ></FontAwesomeIcon>
                </div>
                <p>+420 778 002 968</p>
              </div>

              <div className={styles.iconList}>
                <div className="pr-2">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className={styles.phoneIcon}
                  ></FontAwesomeIcon>
                </div>
                <p>jan.svanda@eapp.cz</p>
              </div>
            </div>
            <p>
              Experiences, education and more on:{" "}
              <a
                href="https://www.linkedin.com/in/jan-%C5%A1vanda-734579208/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Call;
